export default `public class CannyTokenCreator
{
  private static string PrivateKey = "YOUR_PRIVATE_SSO_KEY";

  public static string CreateToken(User user)
  {
    byte[] keyBytes = Encoding.UTF8.GetBytes(PrivateKey);
    var securityKey = new SymmetricSecurityKey(keyBytes);

    var credentials = new SigningCredentials(securityKey, "HS256");
    var header = new JwtHeader(credentials);
    var payload = new JwtPayload
    {
      { "avatarURL": user.avatarURL }, // optional, but preferred
      { "email": user.email },
      { "id": user.id },
      { "name": user.name }
    };

    var securityToken = new JwtSecurityToken(header, payload);
    var handler = new JwtSecurityTokenHandler();

    return handler.WriteToken(securityToken);
  }
}`;
